import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './RenewalStatusForm.module.scss'
import Button from '../../Button'
import { RenewalStatus } from '../../../models'

function RenewalStatusForm({ renewalStatus, school }) {
  const [state, setState] = useState(renewalStatus)
  const [isSaved, setIsSaved] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    const renewalStatusServer = await RenewalStatus.find(renewalStatus.id).then(res => res.data)
    renewalStatusServer.attributes = { ...renewalStatusServer.attributes, ...state }

    renewalStatusServer
      .save()
      .then(() => setIsSaved(true))
  }

  const handleChange = (e) => {
    const { target: { name, value } } = e

    setState({ ...state, [name]: value })
  }

  return (
    <div class="panel panel-default">
      <div class="panel-body">
        {isSaved && (
          <div className={styles.updateMessage}>
            Successfully updated
            <span onClick={() => setIsSaved(false)}>x</span>
          </div>
        )}
        {/* <h3>Renewal Status for {school.name}</h3> */}
        <form onSubmit={handleSubmit} className={styles.form}>
          {/* <div> */}
            {/* <label>Status</label> */}
            {/* <input name="status" value={state.status || ''} onChange={handleChange} /> */}
          {/* </div> */}
          <div>
            <label>Renewal notes:</label>
            <textarea name="note" rows='3' resize='none' value={state && state.note ? state.note : ''} onChange={handleChange} />
          </div>
          <Button rounded type="submit" variant="primary">Update renewal notes</Button>
        </form>
      </div>
    </div>
  )
}

RenewalStatusForm.propTypes = {
  renewalStatus: PropTypes.shape({
    id: PropTypes.number.isRequired,
    school_id: PropTypes.number.isRequired,
    note: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  school: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
}

export default RenewalStatusForm;
